<template>
  <div id='delaccount'>
       <NavTop title='更多'/>
       <van-cell-group inset>
       <van-cell title="注销账号" is-link @click='doDelAccount'/>
     </van-cell-group>
  </div>
</template>
<script>
import {Cell, CellGroup,Dialog } from 'vant'
import NavTop from '@/components/navtop'

export default {
   name: 'delaccount',
   data() {
        return {
    
        };
   }, 
   methods: {
     doDelAccount(){
          Dialog.confirm({
               title: '温馨提醒',
               message: '您确认要注销此账号吗？注销后将无法登陆系统',
               })
               .then(() => {
                    this.$post("/user/delAccount",{}).then((data)=>{
                        if(data.result.success){
                             this.$toast(data.result.info)
                             this.$store.dispatch("doLogout")
                             setTimeout(()=>{
                                this.$go("/login")
                             },1500)
                        }
                    })
               })
               .catch(() => {
               });
     }
   },
   components: {
        [Cell.name]:Cell,
        [CellGroup.name]:CellGroup,
        [Dialog.Component.name]: Dialog.Component,
        NavTop
   }
}
</script>
<style scoped>
#delaccount{background-color:#F6F6F6;min-height: 100vh;}
::v-deep .van-cell__title{text-align: left;}
::v-deep .van-cell__value{text-align: right;}
.title-center{text-align: center!important;}
.title-right{text-align: right!important;}
::v-deep .van-cell-group--inset{margin:0 0.25rem;}

</style>